import { useEffect, useState, Fragment } from 'react';
import { Select, Button, Form, DatePicker, Input, Radio, Checkbox } from 'antd';
import { useTranslation } from 'react-i18next';
import DataBreachService from '../../../../../services/DataBreach.service';
import useNotify from '../../../../../context/Notification/useNotify';
import ModalFail from '../../../../../components/Shared/modal/fail';
import ModalSuccess from '../../../../../components/Shared/modal/success';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

export const personalList = [
    {
        key: 1,
        nameEn: 'Data revealing racial or ethnic origin',
        nameTh: 'ข้อมูลที่เปิดเผยเชื้อชาติหรือชาติพันธุ์',
    },
    {
        key: 2,
        nameEn: 'Political opinions',
        nameTh: 'ความคิดเห็นทางการเมือง',
    },
    {
        key: 3,
        nameEn: 'Religious or philosophical beliefs',
        nameTh: 'ความเชื่อทางศาสนาหรือปรัชญา',
    },
    {
        key: 4,
        nameEn: 'Trade union membership',
        nameTh: 'การเป็นสมาชิกสหภาพแรงงาน',
    },
    {
        key: 5,
        nameEn: 'Sex life data',
        nameTh: 'ข้อมูลชีวิตทางเพศ',
    },
    {
        key: 6,
        nameEn: 'Sexual orientation data',
        nameTh: 'ข้อมูลด้านรสนิยมทางเพศ',
    },
    {
        key: 7,
        nameEn: 'Gender reassignment data',
        nameTh: 'ข้อมูลการแปลงเพศ',
    },
    {
        key: 8,
        nameEn: 'Health data',
        nameTh: 'ข้อมูลด้านสุขภาพ',
    },
    {
        key: 9,
        nameEn: 'Basic personal identifiers, eg name, contact details or address',
        nameTh: 'ข้อมูลระบุส่วนบุคคลพื้นฐาน เช่น ชื่อ รายละเอียดการติดต่อ หรือที่อยู่',
    },
    {
        key: 10,
        nameEn: 'Identification data, eg usernames or passwords',
        nameTh: 'ข้อมูลระบุตัวตน เช่น ชื่อผู้ใช้หรือรหัสผ่าน',
    },
    {
        key: 11,
        nameEn: 'Economic and financial data, eg credit card numbers or bank details',
        nameTh: 'ข้อมูลทางเศรษฐกิจและการเงิน เช่น หมายเลขบัตรเครดิตหรือรายละเอียดธนาคาร',
    },
    {
        key: 12,
        nameEn: 'Official documents, eg driving licences',
        nameTh: 'เอกสารราชการ เช่น ใบขับขี่',
    },
    {
        key: 13,
        nameEn: 'Location data, eg coordinates',
        nameTh: 'ข้อมูลตำแหน่ง เช่น พิกัด',
    },
    {
        key: 14,
        nameEn: 'Genetic or biometric data',
        nameTh: 'ข้อมูลทางพันธุกรรมหรือข้อมูลชีวมาตร',
    },
    {
        key: 15,
        nameEn: 'Criminal convictions or offences',
        nameTh: 'การถูกตัดสินว่ามีความผิดทางอาญาหรือความผิดทางอาญา',
    },
    {
        key: 17,
        nameEn: 'Other',
        nameTh: 'อื่นๆ',
    },
    {
        key: 18,
        nameEn: 'Employees',
        nameTh: 'พนักงาน',
    },
    {
        key: 19,
        nameEn: 'Users',
        nameTh: 'ผู้ใช้งาน',
    },
    {
        key: 20,
        nameEn: 'Subscribers',
        nameTh: 'สมาชิก',
    },
    {
        key: 21,
        nameEn: 'Students',
        nameTh: 'นักเรียน',
    },
    {
        key: 22,
        nameEn: 'Customers or prospective customers',
        nameTh: 'ลูกค้าหรือลูกค้าเป้าหมาย',
    },
    {
        key: 23,
        nameEn: 'Patients',
        nameTh: 'ผู้ป่วย',
    },
    {
        key: 24,
        nameEn: 'Vulnerable persons, such as minors, the disabled, the disabled, the quasi-incompetent, and persons who lack the capacity to protect their rights and interests',
        nameTh: 'บุคคลเปราะบาง เช่น ผู้เยาว์ ผู้พิการ ผู้ไร้ความสามารถ ผู้เสมือนไร้ความสามารถ บุคคลที่ขาดความสามารถในการปกป้องสิทธิและประโยชน์ของตน ',
    },
    {
        key: 25,
        nameEn: 'Physical Storage such as filing cabinets / archives / storage / data storage devices such as flash drives, disks, magnetic tapes',
        nameTh: 'Physical Storage เช่น ตู้เอกสาร / ห้องเก็บเอกสาร / คลัง / อุปกรณ์บันทึกข้อมูล เช่น แฟลชไดร์ แผ่นดิสก์ เทปแม่เหล็ก',
    },
    {
        key: 26,
        nameEn: 'Electronic Storage such as servers / cloud / electronic devices such as personal computers, notebooks, smartphones, tablets.',
        nameTh: 'Electronic Storage เช่น เซิร์ฟเวอร์ (server) / คลาวด์ (cloud) / อุปกรณ์อิเล็กทรอนิกส์ เช่น คอมพิวเตอร์ส่วนบุคคล โน้ตบุ๊ค สมาร์ทโฟน แท็บเล็ต',
    },
    {
        key: 27,
        nameEn: 'There is a backup (backup).',
        nameTh: 'มีการสำรองข้อมูล (backup)',
    },
    {
        key: 28,
        nameEn: 'Access control is defined to allow individuals to access, change, delete or transfer information.',
        nameTh: 'มีการกำหนดสิทธิบุคคล (access control) ที่สามารถเข้าถึง เปลี่ยนแปลง ลบ หรือถ่ายโอน',
    },
    {
        key: 29,
        nameEn: 'Appropriate access and authorization rights are defined.',
        nameTh: 'มีกำหนดสิทธิในการเข้าถึงและใช้งาน (authorization) ที่เหมาะสม',
    },
    {
        key: 30,
        nameEn: 'It is encrypted with reliable technology (encrypt).',
        nameTh: 'มีการเข้ารหัสด้วยเทคโนโลยีที่น่าเชื่อถือ (encrypt)',
    },
    {
        key: 31,
        nameEn: 'All employees are trained in data protection and security.',
        nameTh: 'พนักงานทุกคนได้รับการอบรมเรื่องการปกป้องข้อมูลและการรักษาความปลอดภัย',
    },
];

export default function Tab2Component({
    details,
    permission,
    tab2Form,
    consequence,
    consequenceConvert,
    triggerDetails,
    setTriggerDetails,
    dataBreachLogDetail,
    viewMode,
    setViewMode,
    validateTab2
}) {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    const { t, i18n } = useTranslation('data-breach');
    const lang = i18n?.language;
    const [change, setChange] = useState(false);
    const [editFlag, setEditFlag] = useState(false);
    const [loadinSave, setLoadinSave] = useState(false);
    const [is103Enabled, setIs103Enabled] = useState(false);
    const [is109Enabled, setIs109Enabled] = useState(false);
    const [is202Enabled, setIs202Enabled] = useState(false);
    const [is203Enabled, setIs203Enabled] = useState(false);
    const [is301Enabled, setIs301Enabled] = useState(false);
    const [is302Enabled, setIs302Enabled] = useState(false);
    const [q8Options, setQ8Options] = useState([]);

    const [openModalStatus, setOpenModalStatus] = useState(undefined);
    const notify = useNotify();

    const handleCheckbox = (value, fieldName, setEnabled, isEnabled) => {
        if (value === 17) {
            setEnabled(!isEnabled);
        }

        if (!isEnabled) {
            tab2Form.setFields([
                {
                    name: fieldName,
                    errors: [],
                },
            ]);
        }
    };

    const handleSelectChange = (value, fieldName, setEnabled) => {
        const isEnabled = value === 2;
        setEnabled(isEnabled);

        if (!isEnabled) {
            tab2Form.setFields([
                {
                    name: fieldName,
                    errors: [],
                },
            ]);
        }
    };

    const handleSelectYes = (value, fieldName, setEnabled) => {
        const isEnabled = value === 1;
        setEnabled(isEnabled);

        if (!isEnabled) {
            tab2Form.setFields([
                {
                    name: fieldName,
                    errors: [],
                },
            ]);
        }
    };
    const handle401Change = (value) => {
        tab2Form.resetFields(['question403']);
        let choice = [];
        if (value === 12) {
            choice = [answerMap[17], answerMap[18]];
        } else {
            choice = [
                answerMap[19],
                answerMap[20],
                answerMap[21],
                answerMap[22],
            ];
        }
        setQ8Options(choice);
    };

    const cancelForm = () => {
        tab2Form.resetFields();
        setViewMode(true);
    };

    useEffect(() => {
        validateTab2 && tab2Form.validateFields();
    }, [validateTab2]);

    useEffect(() => {
        if(consequenceConvert) {
            if (consequenceConvert?.question103 === 2) {
                setIs103Enabled(true);
            }
            if (consequenceConvert?.question202?.length > 0) {
                consequenceConvert?.question202.includes(17) && setIs202Enabled(true);
            }
            if (consequenceConvert?.question203?.length > 0) {
                consequenceConvert?.question203.includes(17) && setIs203Enabled(true);
            }
            if (consequenceConvert?.question301?.length > 0) {
                consequenceConvert?.question301.includes(17) && setIs301Enabled(true);
            }
            if (consequenceConvert?.question302?.length > 0) {
                consequenceConvert?.question302.includes(17) && setIs302Enabled(true);
            }
        }
       
    }, [consequenceConvert]);


    const answerMap = [
        {
            id: 1,
            nameEn: 'Yes',
            nameTh: 'ใช่',
        },
        {
            id: 2,
            nameEn: 'No',
            nameTh: 'ไม่',
        },
        {
            id: 3,
            nameEn: 'I don’t know',
            nameTh: 'ฉันไม่ทราบ',
        },
        {
            id: 4,
            nameEn: 'Don’t know',
            nameTh: 'ไม่ทราบ',
        },
        {
            id: 5,
            nameEn: 'Very confident - I know what to do',
            nameTh: 'มั่นใจมาก - ฉันรู้ว่าต้องทำอย่างไร',
        },
        {
            id: 6,
            nameEn: "Somewhat confident - I know what to do next but I'd like advice from the PDPC",
            nameTh: 'ค่อนข้างมั่นใจ - ฉันรู้ว่าต้องทำอย่างไรต่อไป แต่ฉันอยากได้คำแนะนำจาก สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (สคส.)',
        },
        {
            id: 7,
            nameEn: "Not confident - I'd like the PDPC's help to manage the breach properly",
            nameTh: 'ไม่มั่นใจ - ฉันต้องการความช่วยเหลือจาก สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (สคส.) เพื่อจัดการกับการละเมิดอย่างเหมาะสม',
        },
        {
            id: 8,
            nameEn: 'We have successfully recovered from the incident, with all personal data in the same state as it was shortly before the incident.',
            nameTh: 'เราได้ฟื้นตัวจากเหตุการณ์ดังกล่าวได้สำเร็จ โดยข้อมูลส่วนตัวทั้งหมดอยู่ในสถานะเดียวกับก่อนเกิดเหตุการณ์ไม่นาน',
        },
        {
            id: 9,
            nameEn: 'We are in the process of restoring all personal data to the state it was in shortly before the incident.',
            nameTh: 'เรากำลังอยู่ในขั้นตอนการกู้คืนข้อมูลส่วนบุคคลทั้งหมดให้กลับไปสู่สถานะเดิมไม่นานก่อนเกิดเหตุการณ์',
        },
        {
            id: 10,
            nameEn: 'We cannot restore personal data to the state it was in shortly before the incident. For example, backups fail, there is no current backup, or backups are encrypted.',
            nameTh: 'เราไม่สามารถกู้คืนข้อมูลส่วนตัวให้กลับไปเป็นสถานะเดิมได้ในช่วงสั้นๆ ก่อนเกิดเหตุ ตัวอย่างเช่น การสำรองข้อมูลล้มเหลว ไม่มีการสำรองข้อมูลในปัจจุบัน หรือข้อมูลสำรองถูกเข้ารหัส',
        },
        {
            id: 11,
            nameEn: 'We have not yet determined whether personal data can be restored to the state it was in before the incident.',
            nameTh: 'เรายังไม่ได้กำหนดว่าข้อมูลส่วนบุคคลสามารถคืนสู่สภาพเดิมก่อนเกิดเหตุการณ์ได้หรือไม่',
        },
        {
            id: 12,
            nameEn: 'Individual',
            nameTh: 'บุคคลธรรมดา',
        },
        {
            id: 13,
            nameEn: 'Juristic person',
            nameTh: 'นิติบุคคล',
        },
        {
            id: 14,
            nameEn: '1-10 staff or volunteers',
            nameTh: 'พนักงานหรืออาสาสมัคร 1-10 คน',
        },
        {
            id: 15,
            nameEn: '11-50 staff or volunteers',
            nameTh: 'พนักงานหรืออาสาสมัคร 11-50 คน',
        },
        {
            id: 16,
            nameEn: '51-249 staff or volunteers',
            nameTh: 'พนักงานหรืออาสาสมัคร 51-249 คน',
        },
        {
            id: 17,
            nameEn: '250+ staff or volunteers',
            nameTh: 'พนักงานหรืออาสาสมัครมากกว่า 250 คน',
        },
        {
            id: 18,
            nameEn: 'Owner business',
            nameTh: 'กิจการเจ้าของคนเดียว',
        },
        {
            id: 19,
            nameEn: 'Unregistered general partnership',
            nameTh: 'ห้างหุ้นส่วนสามัญไม่จดทะเบียน',
        },
        {
            id: 20,
            nameEn: 'Registered general partnership and limited partnership',
            nameTh: 'ห้างหุ้นส่วนสามัญที่จดทะเบียน และ ห้างหุ้นส่วนจำกัด',
        },
        {
            id: 21,
            nameEn: 'Company limited',
            nameTh: 'บริษัทจำกัด',
        },
        {
            id: 22,
            nameEn: 'Public Company Limited',
            nameTh: 'บริษัทมหาชนจำกัด',
        },
        {
            id: 23,
            nameEn: 'Business organizations established or registered under specific laws',
            nameTh: 'องค์กรธุรกิจจัดตั้งหรือจดทะเบียนภายใต้กฎหมายเฉพาะ',
        },
        {
            id: 24,
            nameEn: 'Not sure',
            nameTh: 'ไม่แน่ใจ',
        },
    ];
    const q1Options = [answerMap[0], answerMap[1]];
    const q2Options = [answerMap[0], answerMap[1], answerMap[2]];
    const q3Options = [answerMap[0], answerMap[1], answerMap[23]];
    const q4Options = [answerMap[4], answerMap[5], answerMap[6]];
    const q5Options = [answerMap[7], answerMap[8], answerMap[9], answerMap[10]];

    const q6Options = [answerMap[11], answerMap[12]];

    const q7Options = [
        answerMap[13],
        answerMap[14],
        answerMap[15],
        answerMap[16],
    ];

    const qPersonalList = [
        personalList[0],
        personalList[1],
        personalList[2],
        personalList[3],
        personalList[4],
        personalList[5],
        personalList[6],
        personalList[7],
        personalList[8],
        personalList[9],
        personalList[10],
        personalList[11],
        personalList[12],
        personalList[13],
        personalList[14],
        personalList[15],
    ];

    const qPersonalList2 = [
        personalList[16],
        personalList[17],
        personalList[18],
        personalList[19],
        personalList[20],
        personalList[21],
        personalList[22],
        personalList[15],
    ];

    const qPersonalList3 = [
        personalList[23],
        personalList[24],
        personalList[15],
    ];

    const qPersonalList4 = [
        personalList[25],
        personalList[26],
        personalList[27],
        personalList[28],
        personalList[29],
        personalList[15],
    ];
    const handleEdit = () => {
        setViewMode(false);
    };
    const checkValidate = (values) => {
        const questions = [
            { answerField: 'question103', areaField: 'question103Input' },
            { answerField: 'question202', areaField: 'question202Input' },
            { answerField: 'question203', areaField: 'question203Input' },
            { answerField: 'question301', areaField: 'question301Input' },
            { answerField: 'question302', areaField: 'question302Input' },
        ];
    
        let firstErrorField = null; // To store the first field with an error
    
        questions.forEach(({ answerField, areaField }) => {
            if (Array.isArray(values[answerField])) {
                if (values[answerField].includes(17) && !values[areaField]) {
                    tab2Form.setFields([
                        {
                            name: areaField,
                            errors: [t('requiredField')],
                        },
                    ]);
                    if (!firstErrorField) firstErrorField = areaField; // Capture the first invalid field
                } else {
                    tab2Form.setFields([
                        {
                            name: areaField,
                            errors: [],
                        },
                    ]);
                }
            } else {
                if (values[answerField] === 2) {
                    if (!values[areaField]) {
                        tab2Form.setFields([
                            {
                                name: areaField,
                                errors: [t('requiredField')],
                            },
                        ]);
                        if (!firstErrorField) firstErrorField = areaField;
                    } else {
                        tab2Form.setFields([
                            {
                                name: areaField,
                                errors: [],
                            },
                        ]);
                    }
                } else {
                    tab2Form.setFields([
                        {
                            name: areaField,
                            errors: [],
                        },
                    ]);
                }
            }
        });
    
        // Scroll to the first invalid field
        if (firstErrorField) {
            setTimeout(() => {
                tab2Form.scrollToField(firstErrorField, {
                    behavior: 'smooth',
                    block: 'center',
                });
            }, 100);
        }
    };
    

    const onFinish = async (values) => {
        try {
            await checkValidate(values);
            await tab2Form.validateFields(); // Ensure validation is done properly

            const errors = tab2Form.getFieldsError().filter(({ errors }) => errors.length > 0);

            if (errors.length > 0) {
                const firstErrorField = errors[0].name[0]; // Get the first field with an error
                tab2Form.scrollToField(firstErrorField, {
                    behavior: "smooth",
                    block: "center",
                });
                return; // Stop execution if errors exist
            }
            
            const payload = {
                txnDataBreachId: details,
                answer: JSON.stringify(values),
                outcome:
                    tab2Form.getFieldValue('question303') === 24
                        ? 3
                        : tab2Form.getFieldValue('question303'),
            };
    
            if (consequence.length > 0 || Object.keys(consequence).length !== 0) {
                DataBreachService.updateConsequence(payload)
                    .then((res) => {
                        if (res.data.resultMsg === 'SUCCESS') {
                            setOpenModalStatus(true);
                        } else {
                            setOpenModalStatus(false);
                        }
                        setTriggerDetails(!triggerDetails);
                        setLoadinSave(false);
                        setViewMode(false);
                    })
                    .catch((err) => {
                        notify({
                            type: 'error',
                            title: t('Fail'),
                            description: t('FailedtoSubmitData'),
                            closeable: true,
                            timeOut: 120000,
                        });
                        setLoadinSave(false);
                    });
            } else {
                DataBreachService.saveConsequence(payload)
                    .then((res) => {
                        if (res.data.resultMsg === 'SUCCESS') {
                            setOpenModalStatus(true);
                        } else {
                            setOpenModalStatus(false);
                        }
                        setTriggerDetails(!triggerDetails);
                        setLoadinSave(false);
                    })
                    .catch((err) => {
                        setLoadinSave(false);
                        notify({
                            type: 'error',
                            title: t('Fail'),
                            description: t('FailedtoSubmitData'),
                            closeable: true,
                            timeOut: 120000,
                        });
                    });
            }
        } catch (error) {
            console.error('Validation failed:', error);
            setLoadinSave(false); // Ensure loading state resets
        }
    };
    
    const handleInputChange = (event, field) => {
        const value = event.target.value;

        if (value && value.trim() !== '') {
            // Reset error message
            tab2Form.setFields([
                {
                    name: field,
                    errors: [],
                },
            ]);
        } else {
            // Trigger validation
            tab2Form.validateFields([field]);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return null;
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Asia/Bangkok',
        }).format(date);
    };

    const getConsequenceText = (value, map, language = 'nameTh') => {
        lang === 'en' ? (language = 'nameEn') : (language = 'nameTh');
        const matchedItem = map.find((item) => item.id === value);
        return matchedItem ? matchedItem[language] : '-';
    };

    const getMappedTexts = (values, map, language = "nameTh") => {
        if (!Array.isArray(values) || !Array.isArray(map)) {
            return [];
        }
        return values.map((value) => {
            const matchedItem = map.find((item) => item.key === value);
            return matchedItem ? matchedItem[language] : "-";
        });
    };

    return (
        <>
            <div>
                <h5 className="text-base font-semibold">
                    {t('Informing Other Parties')}
                </h5>
                {viewMode ? (
                    <>
                        <div className="bg-[#FFF7E6] rounded p-4">
                            <div className="flex items-center">
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M9.00008 2.33341C7.23197 2.33341 5.53628 3.03579 4.28604 4.28604C3.03579 5.53628 2.33341 7.23197 2.33341 9.00008C2.33341 10.7682 3.03579 12.4639 4.28604 13.7141C5.53628 14.9644 7.23197 15.6667 9.00008 15.6667C10.7682 15.6667 12.4639 14.9644 13.7141 13.7141C14.9644 12.4639 15.6667 10.7682 15.6667 9.00008C15.6667 7.23197 14.9644 5.53628 13.7141 4.28604C12.4639 3.03579 10.7682 2.33341 9.00008 2.33341ZM0.666748 9.00008C0.666748 4.39758 4.39758 0.666748 9.00008 0.666748C13.6026 0.666748 17.3334 4.39758 17.3334 9.00008C17.3334 13.6026 13.6026 17.3334 9.00008 17.3334C4.39758 17.3334 0.666748 13.6026 0.666748 9.00008Z"
                                        fill="#FF6E04"
                                    />
                                    <path
                                        d="M9 7.33333C9.22101 7.33333 9.43298 7.42113 9.58926 7.57741C9.74554 7.73369 9.83333 7.94565 9.83333 8.16667V13.1667C9.83333 13.3877 9.74554 13.5996 9.58926 13.7559C9.43298 13.9122 9.22101 14 9 14C8.77899 14 8.56702 13.9122 8.41074 13.7559C8.25446 13.5996 8.16667 13.3877 8.16667 13.1667V8.16667C8.16667 7.94565 8.25446 7.73369 8.41074 7.57741C8.56702 7.42113 8.77899 7.33333 9 7.33333ZM10.25 5.25C10.25 5.58152 10.1183 5.89946 9.88388 6.13388C9.64946 6.3683 9.33152 6.5 9 6.5C8.66848 6.5 8.35054 6.3683 8.11612 6.13388C7.8817 5.89946 7.75 5.58152 7.75 5.25C7.75 4.91848 7.8817 4.60054 8.11612 4.36612C8.35054 4.1317 8.66848 4 9 4C9.33152 4 9.64946 4.1317 9.88388 4.36612C10.1183 4.60054 10.25 4.91848 10.25 5.25Z"
                                        fill="#FF6E04"
                                    />
                                </svg>
                                <p className="mb-0 ml-1 text-base font-bold text-[#FF6E04]">
                                    {t(
                                        'Before you start filling out the form below'
                                    )}
                                </p>
                            </div>
                            <p className="mb-0 ml-1 text-sm	 font-semibold text-[#171717]">
                                {t(
                                    'Please make sure you have prepared the following information'
                                )}
                            </p>
                            <ul>
                                <li className="text-sm text-[#171717]">
                                    <span className="font-semibold">
                                        {t('Details of the violation')}
                                    </span>{' '}
                                    -{' '}
                                    {t(
                                        'General overview of the violation the date and time it occurred, and when you discovered it'
                                    )}
                                </li>
                                <li className="text-sm text-[#171717]">
                                    <span className="font-semibold">
                                        {t('Employee details')}
                                    </span>{' '}
                                    -{' '}
                                    {t(
                                        'Which employees are involved and what data protection training have they received'
                                    )}
                                </li>
                                <li className="text-sm text-[#171717]">
                                    <span className="font-semibold">
                                        {t(
                                            'Details of the data and individuals affected'
                                        )}
                                    </span>{' '}
                                    -{' '}
                                    {t(
                                        'The volume of data and the number of individuals impacted and the potential risks that may arise for each individual as a result of the breach'
                                    )}
                                </li>
                                <li className="text-sm text-[#171717]">
                                    <span className="font-semibold">
                                        {t(
                                            'Your efforts to control the breach'
                                        )}
                                    </span>{' '}
                                    -{' '}
                                    {t(
                                        'What preventative measures were previously in place what actions have you taken to prevent such incidents from occurring again and which other organizations have you already notified or need to notify about the breach'
                                    )}
                                </li>
                            </ul>
                            <p className="mb-0 ml-1 text-sm	 font-semibold text-[#171717]">
                                {t('Note')}
                            </p>
                            <ul>
                                <li className="text-sm text-[#171717]">
                                    {t(
                                        'This form takes approximately 30 minutes to fill out'
                                    )}
                                </li>
                                <li className="text-sm text-[#171717]">
                                    {t(
                                        'In the case where someone reports an incident through the personal data breach notification form you can refer to the provided notification information below to assist in filling out the form'
                                    )}
                                </li>
                                <li className="text-sm text-[#171717]">
                                    {t(
                                        'The information you provide must be accurate You should include as much detail as possible in this form'
                                    )}
                                </li>
                                <li className="text-sm text-[#171717]">
                                    {t(
                                        'Please do not include any personal data related to the breach when filling out this form such as refraining from specifying the names of individuals whose data has been affected by the breach'
                                    )}
                                </li>
                            </ul>
                        </div>
                        <h5 className="pt-6 mb-0 text-base font-semibold text-[#7B67FB]">
                            1. {t('Details of the violation')}
                        </h5>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.1)`} {t('When did the violation occur')}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question101 || '-'}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.2)`}{' '}
                                {t('When did you find out about the breach')}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {formatDate(consequenceConvert?.question102) ||
                                    '-'}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.3)`}{' '}
                                {t(
                                    'Are you reporting the breach within 72 hours of finding out about it'
                                )}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {getConsequenceText(
                                    consequenceConvert?.question103,
                                    answerMap,
                                    ''
                                )}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {t(
                                    'Why were you delayed in reporting the breach'
                                )}{' '}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question103Input || '-'}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.4)`}{' '}
                                {t(
                                    'How did the organisation find out the breach had happened'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question104 || '-'}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.5)`} {t('What happened')}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question105 || '-'}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.6)`}{' '}
                                {t(
                                    'Was the breach caused by a cyber security attack'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {getConsequenceText(
                                    consequenceConvert?.question106,
                                    answerMap,
                                    ''
                                )}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.7)`} {t('How did the breach happen')}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question107 || '-'}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.8)`}{' '}
                                {t(
                                    'Are you able to identify staff members involved in this breach'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {getConsequenceText(
                                    consequenceConvert?.question108,
                                    answerMap,
                                    ''
                                )}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm font-semibold">
                                {t(
                                    'We understand that mistakes happen in organisations Unless the person has purposefully and maliciously caused the breach they will not be held responsible We ask this question to get a full picture of what happened'
                                )}
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {getConsequenceText(
                                    consequenceConvert?.question109,
                                    answerMap,
                                    ''
                                )}
                            </p>
                        </div>
                        <hr className="border-b border-solid border-[#ECECEC]"></hr>
                        <h5 className="mb-0 text-base font-semibold text-[#7B67FB]">
                            2.{' '}
                            {t(
                                'About the data and people affected by the breach'
                            )}
                        </h5>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`2.1)`}{' '}
                                {t(
                                    'What personal data is involved in the breach'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question201 || '-'}
                            </p>
                        </div>
                        <div className="pt-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`2.2)`}{' '}
                                {t(
                                    'What categories of personal data were included in the breach'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Select at least 1 item')})
                                </span>
                                <span className="text-error pl-2">*</span>
                            </p>
                            <ul className="mb-0 text-sm font-normal pt-2 pl-6">
                                {getMappedTexts(consequenceConvert?.question202, personalList).map((text, index) => (
                                    <li key={index}>{text}</li>
                                ))}
                            </ul>
                        </div>
                        {consequenceConvert?.question202Input && <div>
                            <p className="mb-0 text-sm font-semibold">
                                {t(
                                    'Give details of the other categories of data'
                                )}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question202Input}
                            </p>
                        </div>}
                        <div className="pt-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`2.3)`}{' '}
                                {t(
                                    'What categories of people were affected by the breach'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Select at least 1 item')})
                                </span>
                                <span className="text-error pl-2">*</span>
                            </p>
                            <ul className="mb-0 text-sm font-normal pt-2 pl-6">
                                {getMappedTexts(consequenceConvert?.question203, personalList).map((text, index) => (
                                    <li key={index}>{text}</li>
                                ))}
                            </ul>
                        </div>
                        { consequenceConvert?.question203Input && <div>
                            <p className="mb-0 text-sm font-semibold">
                                {t(
                                    'Give details of the other categories of data'
                                )}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question203Input}
                            </p>
                        </div> }
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`2.4)`}{' '}
                                {t('How many people could be affected')}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question204 || '-'}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`2.5)`}{' '}
                                {t(
                                    'How many personal data records have been affected'
                                )}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question205 || '-'}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`2.6)`}{' '}
                                {t(
                                    'What was or could be the harm to individuals'
                                )}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question206 || '-'}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`2.7)`}{' '}
                                {t(
                                    'Is the personal data breach likely to result in a high risk to data subjects'
                                )}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question207 || '-'}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`2.8)`}{' '}
                                {t(
                                    'Is the personal data breach likely to result in a high risk to data subjects'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {getConsequenceText(
                                    consequenceConvert?.question208,
                                    answerMap,
                                    ''
                                )}
                            </p>
                        </div>
                        <hr className="border-b border-solid border-[#ECECEC]"></hr>
                        <h5 className="mb-0 text-base font-semibold text-[#7B67FB]">
                            3. {t('Containing the breach')}
                        </h5>
                        <div className="pt-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`3.1)`}{' '}
                                {t(
                                    'Characteristics of the personal data storage system involved in the breach'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Select at least 1 item')})
                                </span>
                                <span className="text-error pl-2">*</span>
                            </p>
                            <ul className="mb-0 text-sm font-normal pt-2 pl-6">
                                {getMappedTexts(consequenceConvert?.question301, personalList).map((text, index) => (
                                    <li key={index}>{text}</li>
                                ))}
                            </ul>
                        </div>
                        {consequenceConvert?.question302Input &&  <div>
                            <p className="mb-0 text-sm font-semibold">
                                {t(
                                    'Give details of the other categories of data'
                                )}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question302Input}
                            </p>
                        </div>}
                        <div className="pt-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`3.2)`}{' '}
                                {t(
                                    'What preventative measures did you have in place at the time of the breach'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Select at least 1 item')})
                                </span>
                                <span className="text-error pl-2">*</span>
                            </p>
                            <ul className="mb-0 text-sm font-normal pt-2 pl-6">
                                {getMappedTexts(consequenceConvert?.question302, personalList).map((text, index) => (
                                    <li key={index}>{text}</li>
                                ))}
                            </ul>
                        </div>
                        {consequenceConvert?.question302Input &&  <div>
                            <p className="mb-0 text-sm font-semibold">
                                {t(
                                    'Give details of the other categories of data'
                                )}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question302Input}
                            </p>
                        </div> }
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`3.3)`}{' '}
                                {t(
                                    'Is a personal data breach likely to result in a high risk to the data owner'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {getConsequenceText(
                                    consequenceConvert?.question303,
                                    answerMap,
                                    ''
                                )}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`3.4)`}{' '}
                                {t(
                                    'How confident are you that you can manage the effects of the breach and stop it happening again'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {getConsequenceText(
                                    consequenceConvert?.question304,
                                    answerMap,
                                    ''
                                )}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`3.5)`}{' '}
                                {t(
                                    'What steps have you taken to contain the breach and limit its impact'
                                )}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question305 || '-'}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`3.6)`}{' '}
                                {t(
                                    'What is the status of your breach recovery'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {getConsequenceText(
                                    consequenceConvert?.question306,
                                    answerMap,
                                    ''
                                )}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`3.7)`}{' '}
                                {t(
                                    'What steps have you, or will you take to stop a similar breach happening in the future'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question307 || '-'}
                            </p>
                        </div>
                        <hr className="border-b border-solid border-[#ECECEC]"></hr>
                        <h5 className="mb-0 text-base font-semibold text-[#7B67FB]">
                            4. {t('Your organization')}
                        </h5>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`4.1)`}{' '}
                                {t('Legal status of personal data controllers')}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {getConsequenceText(
                                    consequenceConvert?.question401,
                                    answerMap,
                                    ''
                                )}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`4.2)`}{' '}
                                {t('What is the size of your organization')}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {getConsequenceText(
                                    consequenceConvert?.question402,
                                    answerMap,
                                    ''
                                )}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`4.3)`}{' '}
                                {t(
                                    'Nature of the business of the personal data controller'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {getConsequenceText(
                                    consequenceConvert?.question403,
                                    answerMap,
                                    ''
                                )}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`4.4)`} {t('contact address')}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question404 || '-'}
                            </p>
                        </div>
                        <div className="py-3">
                            <p className="mb-0 text-sm	font-semibold">
                                {`4.5)`} {t('contact address details')}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm	font-normal pt-2">
                                {consequenceConvert?.question405 || '-'}
                            </p>
                        </div>
                        {(dataBreachLogDetail.statusEn !== 'New' &&
                            dataBreachLogDetail.statusEn !== 'Resolved' &&
                            dataBreachLogDetail.statusEn !== 'Reject') && <div className="flex justify-end pt-4 stick-bottom">
                                {!permission.viewOnly && (
                                    <Button
                                        onClick={() => handleEdit()}
                                        type="primary"
                                        size="large"
                                        className="w-36"
                                        htmlType="button"
                                        disabled={
                                            !permission.viewEdit ||
                                            dataBreachLogDetail.statusEn === 'New'
                                        }
                                    >
                                        {t('Edit')}
                                    </Button>
                                )}
                            </div>}
                    </>
                ) : (
                    <Form
                        scrollToFirstError={{
                            behavior: 'smooth',
                            block: 'center',
                        }}
                        onFinish={onFinish}
                        form={tab2Form}
                        className="w-full"
                        layout="vertical"
                        onFieldsChange={(_, allFields) => {
                            if (allFields.length > 0) {
                                setChange(true);
                            }
                        }}
                    >
                        <div className="bg-[#FFF7E6] rounded p-4">
                            <div className="flex items-center">
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M9.00008 2.33341C7.23197 2.33341 5.53628 3.03579 4.28604 4.28604C3.03579 5.53628 2.33341 7.23197 2.33341 9.00008C2.33341 10.7682 3.03579 12.4639 4.28604 13.7141C5.53628 14.9644 7.23197 15.6667 9.00008 15.6667C10.7682 15.6667 12.4639 14.9644 13.7141 13.7141C14.9644 12.4639 15.6667 10.7682 15.6667 9.00008C15.6667 7.23197 14.9644 5.53628 13.7141 4.28604C12.4639 3.03579 10.7682 2.33341 9.00008 2.33341ZM0.666748 9.00008C0.666748 4.39758 4.39758 0.666748 9.00008 0.666748C13.6026 0.666748 17.3334 4.39758 17.3334 9.00008C17.3334 13.6026 13.6026 17.3334 9.00008 17.3334C4.39758 17.3334 0.666748 13.6026 0.666748 9.00008Z"
                                        fill="#FF6E04"
                                    />
                                    <path
                                        d="M9 7.33333C9.22101 7.33333 9.43298 7.42113 9.58926 7.57741C9.74554 7.73369 9.83333 7.94565 9.83333 8.16667V13.1667C9.83333 13.3877 9.74554 13.5996 9.58926 13.7559C9.43298 13.9122 9.22101 14 9 14C8.77899 14 8.56702 13.9122 8.41074 13.7559C8.25446 13.5996 8.16667 13.3877 8.16667 13.1667V8.16667C8.16667 7.94565 8.25446 7.73369 8.41074 7.57741C8.56702 7.42113 8.77899 7.33333 9 7.33333ZM10.25 5.25C10.25 5.58152 10.1183 5.89946 9.88388 6.13388C9.64946 6.3683 9.33152 6.5 9 6.5C8.66848 6.5 8.35054 6.3683 8.11612 6.13388C7.8817 5.89946 7.75 5.58152 7.75 5.25C7.75 4.91848 7.8817 4.60054 8.11612 4.36612C8.35054 4.1317 8.66848 4 9 4C9.33152 4 9.64946 4.1317 9.88388 4.36612C10.1183 4.60054 10.25 4.91848 10.25 5.25Z"
                                        fill="#FF6E04"
                                    />
                                </svg>
                                <p className="mb-0 ml-1 text-base font-bold text-[#FF6E04]">
                                    {t(
                                        'Before you start filling out the form below'
                                    )}
                                </p>
                            </div>
                            <p className="mb-0 ml-1 text-sm	 font-semibold text-[#171717]">
                                {t(
                                    'Please make sure you have prepared the following information'
                                )}
                            </p>
                            <ul>
                                <li className="text-sm text-[#171717]">
                                    <span className="font-semibold">
                                        {t('Details of the violation')}
                                    </span>{' '}
                                    -{' '}
                                    {t(
                                        'General overview of the violation the date and time it occurred, and when you discovered it'
                                    )}
                                </li>
                                <li className="text-sm text-[#171717]">
                                    <span className="font-semibold">
                                        {t('Employee details')}
                                    </span>{' '}
                                    -{' '}
                                    {t(
                                        'Which employees are involved and what data protection training have they received'
                                    )}
                                </li>
                                <li className="text-sm text-[#171717]">
                                    <span className="font-semibold">
                                        {t(
                                            'Details of the data and individuals affected'
                                        )}
                                    </span>{' '}
                                    -{' '}
                                    {t(
                                        'The volume of data and the number of individuals impacted and the potential risks that may arise for each individual as a result of the breach'
                                    )}
                                </li>
                                <li className="text-sm text-[#171717]">
                                    <span className="font-semibold">
                                        {t(
                                            'Your efforts to control the breach'
                                        )}
                                    </span>{' '}
                                    -{' '}
                                    {t(
                                        'What preventative measures were previously in place what actions have you taken to prevent such incidents from occurring again and which other organizations have you already notified or need to notify about the breach'
                                    )}
                                </li>
                            </ul>
                            <p className="mb-0 ml-1 text-sm	 font-semibold text-[#171717]">
                                {t('Note')}
                            </p>
                            <ul>
                                <li className="text-sm text-[#171717]">
                                    {t(
                                        'This form takes approximately 30 minutes to fill out'
                                    )}
                                </li>
                                <li className="text-sm text-[#171717]">
                                    {t(
                                        'In the case where someone reports an incident through the personal data breach notification form you can refer to the provided notification information below to assist in filling out the form'
                                    )}
                                </li>
                                <li className="text-sm text-[#171717]">
                                    {t(
                                        'The information you provide must be accurate You should include as much detail as possible in this form'
                                    )}
                                </li>
                                <li className="text-sm text-[#171717]">
                                    {t(
                                        'Please do not include any personal data related to the breach when filling out this form such as refraining from specifying the names of individuals whose data has been affected by the breach'
                                    )}
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h5 className="mb-0 text-base font-semibold text-[#7B67FB]">
                                1. {t('Details of the violation')}
                            </h5>
                            <p className="mb-0 text-sm	font-semibold pt-4">
                                {`1.1)`} {t('When did the violation occur')}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm font-normal">
                                {t(
                                    'Please specify if known the approximate date and time when the breach occurred'
                                )}
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2">
                                <Form.Item
                                    label={false}
                                    className="w-full"
                                    name="question101"
                                >
                                    <Input
                                        size="large"
                                        maxLength={150}
                                        showCount
                                    />
                                </Form.Item>
                            </div>
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.2)`}{' '}
                                {t('When did you find out about the breach')}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm font-normal">
                                {t(
                                    'Please tell us the date someone in your organization first found out the breach happened'
                                )}
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2 flex">
                                <Form.Item
                                    label={false}
                                    className="w-full basis-2/6"
                                    name="question102"
                                    rules={[
                                        {
                                            required: true,
                                            message: t('requiredField'),
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        style={{ width: '100%' }}
                                        size="large"
                                        showTime
                                        format="DD/MM/YYYY HH:mm"
                                        placeholder="DD/MM/YYYY HH:mm"
                                    />
                                </Form.Item>
                            </div>
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.3)`}{' '}
                                {t(
                                    'Are you reporting the breach within 72 hours of finding out about it'
                                )}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2">
                                <Form.Item
                                    label={false}
                                    className="w-full"
                                    name="question103"
                                    rules={[
                                        {
                                            required: true,
                                            message: t('requiredField'),
                                        },
                                    ]}
                                >
                                    <Radio.Group className="w-full">
                                        {q1Options.map((is) => (
                                            <div key={is.id}>
                                                <Radio
                                                    value={is.id}
                                                    style={{
                                                        lineHeight: '32px',
                                                    }}
                                                    onChange={(e) =>
                                                        handleSelectChange(
                                                            e.target.value,
                                                            'question103',
                                                            setIs103Enabled
                                                        )
                                                    }
                                                >
                                                    {lang === 'en'
                                                        ? is.nameEn
                                                        : is.nameTh}
                                                </Radio>
                                            </div>
                                        ))}
                                    </Radio.Group>
                                </Form.Item>
                            </div>
                            {is103Enabled && (
                                <>
                                    <p className="mb-0 text-sm font-semibold">
                                        {t(
                                            'Why were you delayed in reporting the breach'
                                        )}
                                        <span className="text-error pl-2">
                                            *
                                        </span>
                                    </p>
                                    <Form.Item
                                        label={false}
                                        className="w-full"
                                        name="question103Input"
                                    >
                                        <Input.TextArea
                                            size="large"
                                            placeholder={t('specify message')}
                                            maxLength={5000}
                                            showCount
                                            rows={3}
                                            onChange={(e) =>
                                                handleInputChange(
                                                    e,
                                                    'question103Input'
                                                )
                                            }
                                        />
                                    </Form.Item>
                                </>
                            )}
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.4)`}{' '}
                                {t(
                                    'How did the organisation find out the breach had happened'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm font-normal">
                                {t(
                                    'Give details about the events that led to you find out that the breach had happened'
                                )}
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2">
                                <Form.Item
                                    label={false}
                                    className="w-full"
                                    name="question104"
                                >
                                    <Input.TextArea
                                        size="large"
                                        placeholder={t('specify message')}
                                        maxLength={5000}
                                        showCount
                                        rows={3}
                                    />
                                </Form.Item>
                            </div>
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.5)`} {t('What happened')}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm font-normal">
                                {t(
                                    'Give a summary of the breach For example sensitive health information about a number of clients has been found in a filing cabinet donated to a charity shop or an adopted child birth parents have accidentally been given the child current address'
                                )}
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2">
                                <Form.Item
                                    label={false}
                                    className="w-full"
                                    name="question105"
                                    rules={[
                                        {
                                            required: true,
                                            message: t('requiredField'),
                                        },
                                    ]}
                                >
                                    <Input.TextArea
                                        size="large"
                                        placeholder={t('specify message')}
                                        maxLength={5000}
                                        showCount
                                        rows={3}
                                    />
                                </Form.Item>
                            </div>
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.6)`}{' '}
                                {t(
                                    'Was the breach caused by a cyber security attack'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm font-normal">
                                {t(
                                    'A cyber attack is a breach with a clear online or technological element that involves a third party with malicious intent For example incidents involving phishing or malware attacks'
                                )}
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2">
                                <Form.Item
                                    label={false}
                                    className="w-full"
                                    name="question106"
                                >
                                    <Radio.Group className="w-full">
                                        {q2Options.map((is) => (
                                            <div key={is.id}>
                                                <Radio
                                                    value={is.id}
                                                    style={{
                                                        lineHeight: '32px',
                                                    }}
                                                >
                                                    {lang === 'en'
                                                        ? is.nameEn
                                                        : is.nameTh}
                                                </Radio>
                                            </div>
                                        ))}
                                    </Radio.Group>
                                </Form.Item>
                            </div>
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.7)`} {t('How did the breach happen')}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm font-normal">
                                {t(
                                    'Give details about the events leading up to the breach For example during an office refurbishment a filing cabinet was set aside to be emptied then disposed of The cabinet was loaded into a van in error before it had been emptied and delivered to the charity shop'
                                )}
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2">
                                <Form.Item
                                    label={false}
                                    className="w-full"
                                    name="question107"
                                    rules={[
                                        {
                                            required: true,
                                            message: t('requiredField'),
                                        },
                                    ]}
                                >
                                    <Input.TextArea
                                        size="large"
                                        placeholder={t('specify message')}
                                        maxLength={5000}
                                        showCount
                                        rows={3}
                                    />
                                </Form.Item>
                            </div>
                            <p className="mb-0 text-sm	font-semibold">
                                {`1.8)`}{' '}
                                {t(
                                    'Are you able to identify staff members involved in this breach'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm font-normal">
                                {t(
                                    'We understand that mistakes happen in organisations Unless the person has purposefully and maliciously caused the breach they will not be held responsible We ask this question to get a full picture of what happened'
                                )}
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2">
                                <Form.Item
                                    label={false}
                                    className="w-full"
                                    name="question108"
                                >
                                    <Radio.Group className="w-full">
                                        {q3Options.map((is) => (
                                            <div key={is.id}>
                                                <Radio
                                                    value={is.id}
                                                    style={{
                                                        lineHeight: '32px',
                                                    }}
                                                    onChange={(e) =>
                                                        handleSelectYes(
                                                            e.target.value,
                                                            'question109',
                                                            setIs109Enabled
                                                        )
                                                    }
                                                >
                                                    {lang === 'en'
                                                        ? is.nameEn
                                                        : is.nameTh}
                                                </Radio>
                                            </div>
                                        ))}
                                    </Radio.Group>
                                </Form.Item>
                            </div>
                            {is109Enabled &&
                                <>
                                    <p className="mb-0 text-sm	font-semibold">
                                        {t(
                                            'Had the members of staff received data protection training in the two years prior to the breach'
                                        )}
                                        <span className="text-sm ont-semibold pl-2">
                                            ({t('Optional')})
                                        </span>
                                    </p>
                                    <div className="mb-0 text-sm font-normal pt-2">
                                        <Form.Item
                                            label={false}
                                            className="w-full"
                                            name="question109"
                                        >
                                            <Radio.Group className="w-full">
                                                {q3Options.map((is) => (
                                                    <div key={is.id}>
                                                        <Radio
                                                            value={is.id}
                                                            style={{
                                                                lineHeight: '32px',
                                                            }}
                                                        >
                                                            {lang === 'en'
                                                                ? is.nameEn
                                                                : is.nameTh}
                                                        </Radio>
                                                    </div>
                                                ))}
                                            </Radio.Group>
                                        </Form.Item>
                                    </div>
                                </>
                            }
                            <hr className="border-b border-solid border-[#ECECEC]"></hr>
                            <h5 className="mb-0 text-base font-semibold text-[#7B67FB]">
                                2.{' '}
                                {t(
                                    'About the data and people affected by the breach'
                                )}
                            </h5>
                            <p className="mb-0 text-sm	font-semibold pt-4">
                                {`2.1)`}{' '}
                                {t(
                                    'What personal data is involved in the breach'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Optional')})
                                </span>
                            </p>
                            <p className="mb-0 text-sm font-normal">
                                {t(
                                    'Give details about the exact types of data that have been affected by the breach For example the HIV status of patients addresses of looked-after children or client bank details Please be as specific as possible so we can understand the potential risk to individuals'
                                )}
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2">
                                <Form.Item
                                    label={false}
                                    className="w-full"
                                    name="question201"
                                >
                                    <Input.TextArea
                                        size="large"
                                        placeholder={t('specify message')}
                                        maxLength={5000}
                                        showCount
                                        rows={3}
                                    />
                                </Form.Item>
                            </div>
                            <p className="mb-0 text-sm	font-semibold pt-4">
                                {`2.2)`}{' '}
                                {t(
                                    'What categories of personal data were included in the breach'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Select at least 1 item')})
                                </span>
                                <span className="text-error pl-2">*</span>
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2">
                                <Form.Item
                                    label={false}
                                    className="w-full mb-0"
                                    name="question202"
                                    rules={[
                                        {
                                            required: true,
                                            message: t('validateSelect2'),
                                        },
                                    ]}
                                >
                                    <Checkbox.Group className="w-full mb-1 flex flex-col data-breach-checkbox">
                                        {qPersonalList.map((is) => {
                                            return (
                                                <Fragment key={is.key}>
                                                    <Checkbox
                                                        value={is.key}
                                                        style={{
                                                            lineHeight: '32px',
                                                        }}
                                                        onChange={(e) =>
                                                            handleCheckbox(
                                                                e.target.value,
                                                                'question202',
                                                                setIs202Enabled,
                                                                is202Enabled
                                                            )
                                                        }
                                                    >
                                                        {lang === 'en'
                                                            ? is.nameEn
                                                            : is.nameTh}
                                                    </Checkbox>
                                                </Fragment>
                                            );
                                        })}
                                    </Checkbox.Group>
                                </Form.Item>
                            </div>
                            {is202Enabled && (
                                <>
                                    <p className="mb-0 text-sm font-semibold">
                                        {t(
                                            'Give details of the other categories of data'
                                        )}
                                        <span className="text-error pl-2">
                                            *
                                        </span>
                                    </p>
                                    <Form.Item
                                        label={false}
                                        className="w-full"
                                        name="question202Input"
                                    >
                                        <Input.TextArea
                                            size="large"
                                            placeholder={t('specify message')}
                                            maxLength={1000}
                                            showCount
                                            rows={3}
                                            onChange={(e) =>
                                                handleInputChange(
                                                    e,
                                                    'question202Input'
                                                )
                                            }
                                        />
                                    </Form.Item>
                                </>
                            )}
                            <p className="mb-0 text-sm	font-semibold pt-4">
                                {`2.3)`}{' '}
                                {t(
                                    'What categories of people were affected by the breach'
                                )}
                                <span className="text-sm ont-semibold pl-2">
                                    ({t('Select at least 1 item')})
                                </span>
                                <span className="text-error pl-2">*</span>
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2">
                                <Form.Item
                                    label={false}
                                    className="w-full mb-0"
                                    name="question203"
                                    rules={[
                                        {
                                            required: true,
                                            message: t('validateSelect2'),
                                        },
                                    ]}
                                >
                                    <Checkbox.Group className="w-full mb-1 flex flex-col data-breach-checkbox">
                                        {qPersonalList2.map((is) => {
                                            return (
                                                <Fragment key={is.key}>
                                                    <Checkbox
                                                        value={is.key}
                                                        style={{
                                                            lineHeight: '32px',
                                                        }}
                                                        onChange={(e) =>
                                                            handleCheckbox(
                                                                e.target.value,
                                                                'question203',
                                                                setIs203Enabled,
                                                                is203Enabled
                                                            )
                                                        }
                                                    >
                                                        {lang === 'en'
                                                            ? is.nameEn
                                                            : is.nameTh}
                                                    </Checkbox>
                                                </Fragment>
                                            );
                                        })}
                                    </Checkbox.Group>
                                </Form.Item>
                            </div>
                            {is203Enabled && (
                                <>
                                    <p className="mb-0 text-sm font-semibold">
                                        {t(
                                            'Give details of the other categories of data'
                                        )}
                                        <span className="text-error pl-2">
                                            *
                                        </span>
                                    </p>
                                    <Form.Item
                                        label={false}
                                        className="w-full"
                                        name="question203Input"
                                    >
                                        <Input.TextArea
                                            size="large"
                                            placeholder={t('specify message')}
                                            maxLength={1000}
                                            showCount
                                            rows={3}
                                            onChange={(e) =>
                                                handleInputChange(
                                                    e,
                                                    'question203Input'
                                                )
                                            }
                                        />
                                    </Form.Item>
                                </>
                            )}
                            <p className="mb-0 text-sm	font-semibold pt-4">
                                {`2.4)`}{' '}
                                {t('How many people could be affected')}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm font-normal">
                                {t(
                                    'How many peoples data is affected by the breach If you dont know the number please estimate the maximum possible number If you are reporting a cyber incident estimate the maximum possible number of affected people or the total customer base'
                                )}
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2">
                                <Form.Item
                                    label={false}
                                    className="w-full"
                                    name="question204"
                                    rules={[
                                        {
                                            required: true,
                                            message: t('requiredField'),
                                        },
                                    ]}
                                >
                                    <Input
                                        size="large"
                                        maxLength={150}
                                        showCount
                                    />
                                </Form.Item>
                            </div>
                            <p className="mb-0 text-sm	font-semibold pt-4">
                                {`2.5)`}{' '}
                                {t(
                                    'How many personal data records have been affected'
                                )}
                                <span className="text-error pl-2">*</span>
                            </p>
                            <p className="mb-0 text-sm font-normal">
                                {t(
                                    'The number of records refers to the amount of information or documents that have been impacted not the number of people For example one court record could contain personal data about lots of people'
                                )}
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2">
                                <Form.Item
                                    label={false}
                                    className="w-full"
                                    name="question205"
                                    rules={[
                                        {
                                            required: true,
                                            message: t('requiredField'),
                                        },
                                    ]}
                                >
                                    <Input
                                        size="large"
                                        maxLength={150}
                                        showCount
                                    />
                                </Form.Item>
                            </div>
                            <p className="mb-0 text-sm	font-semibold pt-4">
                                {`2.6)`}{' '}
                                {t(
                                    'What was or could be the harm to individuals'
                                )}
                                <span className="text-error pl-2">*</span>{' '}
                            </p>
                            <p className="mb-0 text-sm font-normal">
                                {t(
                                    'You should describe any harm that has arisen'
                                )}
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2">
                                <Form.Item
                                    label={false}
                                    className="w-full"
                                    name="question206"
                                    rules={[
                                        {
                                            required: true,
                                            message: t('requiredField'),
                                        },
                                    ]}
                                >
                                    <Input.TextArea
                                        size="large"
                                        placeholder={t('specify message')}
                                        maxLength={5000}
                                        showCount
                                        rows={3}
                                    />
                                </Form.Item>
                            </div>
                            <p className="mb-0 text-sm	font-semibold pt-4">
                                {`2.7)`}{' '}
                                {t(
                                    'Is the personal data breach likely to result in a high risk to data subjects'
                                )}
                                <span className="text-error pl-2">*</span>{' '}
                            </p>
                            <p className="mb-0 text-sm font-normal">
                                {t(
                                    'Please explain the damage caused or may occur to the business'
                                )}
                            </p>
                            <div className="mb-0 text-sm font-normal pt-2">
                                <Form.Item
                                    label={false}
                                    className="w-full"
                                    name="question207"
                                    rules={[
                                        {
                                            required: true,
                                            message: t('requiredField'),
                                        },
                                    ]}
                                >
                                    <Input.TextArea
                                        size="large"
                                        placeholder={t('specify message')}
                                        maxLength={5000}
                                        showCount
                                        rows={3}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <p className="mb-0 text-sm	font-semibold">
                            {`2.8)`}{' '}
                            {t(
                                'Is the personal data breach likely to result in a high risk to data subjects'
                            )}
                            <span className="text-sm ont-semibold pl-2">
                                ({t('Optional')})
                            </span>
                        </p>
                        <p className="mb-0 text-sm font-normal">
                            {t('A person being put at risk')}
                        </p>
                        <div className="mb-0 text-sm font-normal pt-2">
                            <Form.Item
                                label={false}
                                className="w-full"
                                name="question208"
                            >
                                <Radio.Group className="w-full">
                                    {q3Options.map((is) => (
                                        <div key={is.id}>
                                            <Radio
                                                value={is.id}
                                                style={{ lineHeight: '32px' }}
                                            >
                                                {lang === 'en'
                                                    ? is.nameEn
                                                    : is.nameTh}
                                            </Radio>
                                        </div>
                                    ))}
                                </Radio.Group>
                            </Form.Item>
                        </div>
                        <hr className="border-b border-solid border-[#ECECEC]"></hr>
                        <h5 className="mb-0 text-base font-semibold text-[#7B67FB]">
                            3. {t('Containing the breach')}
                        </h5>
                        <p className="mb-0 text-sm	font-semibold pt-4">
                            {`3.1)`}{' '}
                            {t(
                                'Characteristics of the personal data storage system involved in the breach'
                            )}
                            <span className="text-sm ont-semibold pl-2">
                                ({t('Select at least 1 item')})
                            </span>
                            <span className="text-error pl-2">*</span>
                        </p>
                        <div className="mb-0 text-sm font-normal pt-2">
                            <Form.Item
                                label={false}
                                className="w-full mb-0"
                                name="question301"
                                rules={[
                                    {
                                        required: true,
                                        message: t('validateSelect2'),
                                    },
                                ]}
                            >
                                <Checkbox.Group className="w-full mb-1 flex flex-col data-breach-checkbox">
                                    {qPersonalList3.map((is) => {
                                        return (
                                            <Fragment key={is.key}>
                                                <Checkbox
                                                    value={is.key}
                                                    style={{
                                                        lineHeight: '32px',
                                                    }}
                                                    onChange={(e) =>
                                                        handleCheckbox(
                                                            e.target.value,
                                                            'question301',
                                                            setIs301Enabled,
                                                            is301Enabled
                                                        )
                                                    }
                                                >
                                                    {lang === 'en'
                                                        ? is.nameEn
                                                        : is.nameTh}
                                                </Checkbox>
                                            </Fragment>
                                        );
                                    })}
                                </Checkbox.Group>
                            </Form.Item>
                        </div>
                        {is301Enabled && (
                            <>
                                <p className="mb-0 text-sm font-semibold">
                                    {t(
                                        'Give details of the other categories of data'
                                    )}
                                    <span className="text-error pl-2">*</span>
                                </p>
                                <Form.Item
                                    label={false}
                                    className="w-full"
                                    name="question301Input"
                                >
                                    <Input.TextArea
                                        size="large"
                                        placeholder={t('specify message')}
                                        maxLength={1000}
                                        showCount
                                        rows={3}
                                        onChange={(e) =>
                                            handleInputChange(
                                                e,
                                                'question301Input'
                                            )
                                        }
                                    />
                                </Form.Item>
                            </>
                        )}
                        <p className="mb-0 text-sm	font-semibold pt-4">
                            {`3.2)`}{' '}
                            {t(
                                'What preventative measures did you have in place at the time of the breach'
                            )}
                            <span className="text-sm ont-semibold pl-2">
                                ({t('Select at least 1 item')})
                            </span>
                            <span className="text-error pl-2">*</span>
                        </p>
                        <p className="mb-0 text-sm font-normal">
                            {t('Specify details of the protective measures')}
                        </p>
                        <div className="mb-0 text-sm font-normal pt-2">
                            <Form.Item
                                label={false}
                                className="w-full mb-0"
                                name="question302"
                                rules={[
                                    {
                                        required: true,
                                        message: t('validateSelect2'),
                                    },
                                ]}
                            >
                                <Checkbox.Group className="w-full mb-1 flex flex-col data-breach-checkbox">
                                    {qPersonalList4.map((is) => {
                                        return (
                                            <Fragment key={is.key}>
                                                <Checkbox
                                                    value={is.key}
                                                    style={{
                                                        lineHeight: '32px',
                                                    }}
                                                    onChange={(e) =>
                                                        handleCheckbox(
                                                            e.target.value,
                                                            'question302',
                                                            setIs302Enabled,
                                                            is302Enabled
                                                        )
                                                    }
                                                >
                                                    {lang === 'en'
                                                        ? is.nameEn
                                                        : is.nameTh}
                                                </Checkbox>
                                            </Fragment>
                                        );
                                    })}
                                </Checkbox.Group>
                            </Form.Item>
                        </div>
                        {is302Enabled && (
                            <>
                                <p className="mb-0 text-sm font-semibold">
                                    {t(
                                        'Give details of the other categories of data'
                                    )}
                                    <span className="text-error pl-2">*</span>
                                </p>
                                <Form.Item
                                    label={false}
                                    className="w-full"
                                    name="question302Input"
                                >
                                    <Input.TextArea
                                        size="large"
                                        placeholder={t('specify message')}
                                        maxLength={1000}
                                        showCount
                                        rows={3}
                                        onChange={(e) =>
                                            handleInputChange(
                                                e,
                                                'question302Input'
                                            )
                                        }
                                    />
                                </Form.Item>
                            </>
                        )}
                        <p className="mb-0 text-sm	font-semibold">
                            {`3.3)`}{' '}
                            {t(
                                'Is a personal data breach likely to result in a high risk to the data owner'
                            )}
                            <span className="text-sm ont-semibold pl-2">
                                ({t('Optional')})
                            </span>
                        </p>
                        <div className="mb-0 text-sm font-normal pt-2">
                            <Form.Item
                                label={false}
                                className="w-full"
                                name="question303"
                            >
                                <Radio.Group className="w-full">
                                    {q3Options.map((is) => (
                                        <div key={is.id}>
                                            <Radio
                                                value={is.id}
                                                style={{ lineHeight: '32px' }}
                                            >
                                                {lang === 'en'
                                                    ? is.nameEn
                                                    : is.nameTh}
                                            </Radio>
                                        </div>
                                    ))}
                                </Radio.Group>
                            </Form.Item>
                        </div>
                        <p className="mb-0 text-sm	font-semibold">
                            {`3.4)`}{' '}
                            {t(
                                'How confident are you that you can manage the effects of the breach and stop it happening again'
                            )}
                            <span className="text-sm ont-semibold pl-2">
                                ({t('Optional')})
                            </span>
                        </p>
                        <div className="mb-0 text-sm font-normal pt-2">
                            <Form.Item
                                label={false}
                                className="w-full"
                                name="question304"
                            >
                                <Radio.Group className="w-full">
                                    {q4Options.map((is) => (
                                        <div key={is.id}>
                                            <Radio
                                                value={is.id}
                                                style={{ lineHeight: '32px' }}
                                            >
                                                {lang === 'en'
                                                    ? is.nameEn
                                                    : is.nameTh}
                                            </Radio>
                                        </div>
                                    ))}
                                </Radio.Group>
                            </Form.Item>
                        </div>
                        <p className="mb-0 text-sm	font-semibold pt-4">
                            {`3.5)`}{' '}
                            {t(
                                'What steps have you taken to contain the breach and limit its impact'
                            )}
                            <span className="text-error pl-2">*</span>{' '}
                        </p>
                        <p className="mb-0 text-sm font-normal">
                            {t(
                                'Describe the actions you have taken since discovering the breach to protect'
                            )}
                        </p>
                        <div className="mb-0 text-sm font-normal pt-2">
                            <Form.Item
                                label={false}
                                className="w-full"
                                name="question305"
                                rules={[
                                    {
                                        required: true,
                                        message: t('requiredField'),
                                    },
                                ]}
                            >
                                <Input.TextArea
                                    size="large"
                                    placeholder={t('specify message')}
                                    maxLength={5000}
                                    showCount
                                    rows={3}
                                />
                            </Form.Item>
                        </div>
                        <p className="mb-0 text-sm	font-semibold">
                            {`3.6)`}{' '}
                            {t('What is the status of your breach recovery')}
                            <span className="text-sm ont-semibold pl-2">
                                ({t('Optional')})
                            </span>
                        </p>
                        <div className="mb-0 text-sm font-normal pt-2">
                            <Form.Item
                                label={false}
                                className="w-full"
                                name="question306"
                            >
                                <Radio.Group className="w-full">
                                    {q5Options.map((is) => (
                                        <div key={is.id}>
                                            <Radio
                                                value={is.id}
                                                style={{ lineHeight: '32px' }}
                                            >
                                                {lang === 'en'
                                                    ? is.nameEn
                                                    : is.nameTh}
                                            </Radio>
                                        </div>
                                    ))}
                                </Radio.Group>
                            </Form.Item>
                        </div>
                        <p className="mb-0 text-sm	font-semibold pt-4">
                            {`3.7)`}{' '}
                            {t(
                                'What steps have you, or will you take to stop a similar breach happening in the future'
                            )}
                            <span className="text-sm ont-semibold pl-2">
                                ({t('Optional')})
                            </span>
                        </p>
                        <p className="mb-0 text-sm font-normal">
                            {t(
                                'Describe the actions you have taken since discovering the breach to protect the data and protect affected individuals'
                            )}
                        </p>
                        <div className="mb-0 text-sm font-normal pt-2">
                            <Form.Item
                                label={false}
                                className="w-full"
                                name="question307"
                            >
                                <Input.TextArea
                                    size="large"
                                    placeholder={t('specify message')}
                                    maxLength={5000}
                                    showCount
                                    rows={3}
                                />
                            </Form.Item>
                        </div>
                        <hr className="border-b border-solid border-[#ECECEC]"></hr>
                        <h5 className="mb-0 text-base font-semibold text-[#7B67FB]">
                            4. {t('Your organization')}
                        </h5>
                        <p className="mb-0 text-sm	font-semibold pt-4">
                            {`4.1)`}{' '}
                            {t('Legal status of personal data controllers')}
                            <span className="text-sm ont-semibold pl-2">
                                ({t('Optional')})
                            </span>
                        </p>
                        <div className="mb-0 text-sm font-normal pt-2">
                            <Form.Item
                                label={false}
                                className="w-full"
                                name="question401"
                            >
                                <Radio.Group className="w-full">
                                    {q6Options.map((is) => (
                                        <div key={is.id}>
                                            <Radio
                                                value={is.id}
                                                style={{ lineHeight: '32px' }}
                                                onChange={(e) =>
                                                    handle401Change(
                                                        e.target.value
                                                    )
                                                }
                                            >
                                                {lang === 'en'
                                                    ? is.nameEn
                                                    : is.nameTh}
                                            </Radio>
                                        </div>
                                    ))}
                                </Radio.Group>
                            </Form.Item>
                        </div>
                        <p className="mb-0 text-sm	font-semibold pt-4">
                            {`4.2)`}{' '}
                            {t('What is the size of your organization')}
                            <span className="text-sm ont-semibold pl-2">
                                ({t('Optional')})
                            </span>
                        </p>
                        <div className="mb-0 text-sm font-normal pt-2">
                            <Form.Item
                                label={false}
                                className="w-full"
                                name="question402"
                            >
                                <Radio.Group className="w-full">
                                    {q7Options.map((is) => (
                                        <div key={is.id}>
                                            <Radio
                                                value={is.id}
                                                style={{ lineHeight: '32px' }}
                                            >
                                                {lang === 'en'
                                                    ? is.nameEn
                                                    : is.nameTh}
                                            </Radio>
                                        </div>
                                    ))}
                                </Radio.Group>
                            </Form.Item>
                        </div>
                        <p className="mb-0 text-sm	font-semibold pt-4">
                            {`4.3)`}{' '}
                            {t(
                                'Nature of the business of the personal data controller'
                            )}
                            <span className="text-sm ont-semibold pl-2">
                                ({t('Optional')})
                            </span>
                        </p>
                        <div className="mb-0 text-sm font-normal pt-2">
                            <Form.Item
                                label={false}
                                className="w-full"
                                name="question403"
                            >
                                {q8Options.length > 0 ?
                                    <Radio.Group className="w-full">
                                        {q8Options.map((is) => (
                                            <div key={is.id}>
                                                <Radio
                                                    value={is.id}
                                                    style={{ lineHeight: '32px' }}
                                                >
                                                    {lang === 'en'
                                                        ? is.nameEn
                                                        : is.nameTh}
                                                </Radio>
                                            </div>
                                        ))}
                                    </Radio.Group> : t('Please answer question 4.1 first before proceeding to this question')
                                }

                            </Form.Item>
                        </div>
                        <p className="mb-0 text-sm	font-semibold pt-4">
                            {`4.4)`} {t('contact address')}
                            <span className="text-sm ont-semibold pl-2">
                                ({t('Optional')})
                            </span>
                        </p>
                        <div className="mb-0 text-sm font-normal pt-2">
                            <Form.Item
                                label={false}
                                className="w-full"
                                name="question404"
                            >
                                <Input.TextArea
                                    size="large"
                                    placeholder={t('specify message')}
                                    maxLength={500}
                                    showCount
                                    rows={3}
                                />
                            </Form.Item>
                        </div>
                        <p className="mb-0 text-sm	font-semibold pt-4">
                            {`4.5)`} {t('contact address details')}
                            <span className="text-error pl-2">*</span>{' '}
                        </p>
                        <div className="mb-0 text-sm font-normal pt-2">
                            <Form.Item
                                label={false}
                                className="w-full"
                                name="question405"
                                rules={[
                                    {
                                        required: true,
                                        message: t('requiredField'),
                                    },
                                ]}
                            >
                                <Input.TextArea
                                    size="large"
                                    placeholder={t('specify message')}
                                    maxLength={500}
                                    showCount
                                    rows={3}
                                />
                            </Form.Item>
                        </div>
                        <div className="flex justify-end pt-4 stick-bottom">
                            <Button
                                size="large"
                                type="default"
                                className="text-purple-PHX border-purple-PHX w-full"
                                onClick={() => cancelForm()}
                                style={{
                                    width: 'fit-content',
                                    marginRight: 10,
                                }}
                            >
                                {t('Cancel')}
                            </Button>
                            <Button
                                loading={loadinSave}
                                size="large"
                                htmlType="submit"
                                type="primary"
                                className="w-full"
                                style={{ width: 120 }}
                            >
                                {t('Save')}
                            </Button>
                        </div>
                    </Form>
                )}
            </div>
            {openModalStatus && (
                <ModalSuccess
                    open={openModalStatus}
                    handelClose={() => {
                        setOpenModalStatus(undefined);
                        setEditFlag(false);
                        setViewMode(true);
                    }}
                    handelOk={() => {
                        setOpenModalStatus(undefined);
                        setEditFlag(false);
                        setViewMode(true);
                    }}
                    text={t('Successfully saved data')}
                />
            )}
            <ModalFail
                open={openModalStatus === false}
                handelClose={() => {
                    setOpenModalStatus(undefined);
                }}
                handelOk={() => {
                    setOpenModalStatus(undefined);
                }}
                text={t('Failed to submit data')}
            />
        </>
    );
}
